export const environment = {
  production: true,
  // baseIP: "https://crm.bentray.work/",
  baseIP: "https://crmdev.bentraytech.com/",
  apiPrefix: "api/web/v1/",

  defaultImageUrl: "./assets/images/",
  defaultImagePath: "./assets/dist/img",
};
